import type { Distance, Pixel } from "@pdfking/math"
import { RecordMap } from "@pdfking/tfunc"

import { ToPixels } from "./ToPixels"

export const ConvertDistances = <T extends Record<string, Distance>>(
  options: { unit_to_px: Pixel },
  rect: T
): { [K in keyof T]: Pixel } => RecordMap(v => ToPixels(options, v), rect)
